import React from "react";
import { startCase } from "lodash";

import { color, fontSize } from "style/constants";
import { StyledGrid } from "components/simple";
import styled from "styled-components";

interface Props {
  value: string;
}

interface DotProps {
  color: string;
  size: number;
}

const StyledText = styled.p`
  font-size: ${fontSize.small};
`;

const Dot: React.FC<DotProps> = ({ color, size }: DotProps) => (
  <svg height={`${size}px`} width={`${size}px`} viewBox={`0 0 ${size} ${size}`} fill={color}>
    <circle cx={`${size / 2}`} cy={`${size / 2}`} r={`${size / 2}`} />
  </svg>
);

const StatusDot: React.FC<Props> = ({ value }: Props) => {
  let statusColor;
  switch (value) {
    case "assessments_in_progress":
      statusColor = color.DARKGREEN;
      break;
    case "ready_to_score":
      statusColor = color.DARKPURPLE;
      break;
    case "score_finalized":
      statusColor = color.DARKBLUE;
      break;
    case "ready_for_review":
      statusColor = color.DARKRED;
      break;
    default:
      statusColor = color.SLIDERGRAY;
  }

  return (
    <StyledGrid alignItems="center" container itemMargin="0.2rem">
      <Dot color={statusColor} size={8} />
      <StyledText>{startCase(value.replace(/_/g, " "))}</StyledText>
    </StyledGrid>
  );
};

export default StatusDot;
